module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/Sheinina-Raj-33b809f56721528062831d880a89dee0.png";